(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mc-delivery-zip"] && !Shopify.designMode) return;
  try {
    function initMcDeliveryZip(root){
    if(root.dataset.mcInitialized) return;
    root.dataset.mcInitialized='true';
    const form=document.getElementById(root.dataset.formId);
    const zipForm=root.querySelector('[data-mc-zip-form]');
    const zipInput=zipForm.elements.zip;
    const button=zipForm.querySelector('button[type="submit"]');
    const result=root.querySelector('[data-mc-zip-result]');
    const address=root.querySelector('[data-mc-delivery-address]');
    const change=root.querySelector('[data-mc-change]');
    const stock=root.querySelector('[data-mc-stock]');
    const variants=JSON.parse(root.querySelector('[data-mc-variants]').textContent);
    const showStock=root.dataset.showStock!=='false';
    const lowStockThreshold=Number(root.dataset.lowStockThreshold)||9;
    stock.hidden=!showStock;
    const storageKey='mc-delivery-zip-v1';
    let currentVariantId='';
    let requestId=0;
    function updateStock(){
      if(!showStock)return;
      const input=form?.querySelector('[name="id"]');
      const id=String(input?.value||variants[0]?.id||'');
      if(id===currentVariantId) return;
      currentVariantId=id;
      const variant=variants.find(item=>String(item.id)===id);
      if(!variant){stock.textContent='Select an option to see availability.';return;}
      if(!variant.available){stock.textContent='Currently unavailable for this selection.';return;}
      if(variant.managed==='shopify'&&variant.inventory>0&&variant.policy!=='continue'){
        stock.textContent=variant.inventory<=lowStockThreshold?root.dataset.lowStockText.replaceAll('[quantity]',String(variant.inventory)):root.dataset.inStockText;
      }else if(variant.incoming&&variant.date){
        stock.textContent=`Incoming stock expected ${variant.date}.`;
      }else{
        stock.textContent=root.dataset.availableText;
      }
    }
    function showLocation(location){
      zipInput.value=location.zip;
      address.textContent=`ZIP location: ${location.city}, ${location.state} ${location.zip}`;
      result.textContent=`ZIP ${location.zip} found in ${location.city}, ${location.state}.`;
      zipForm.hidden=true;
      change.hidden=false;
    }
    try{
      const stored=JSON.parse(sessionStorage.getItem(storageKey)||'null');
      if(stored&&/^[0-9]{5}$/.test(stored.zip)&&stored.city&&stored.state)showLocation(stored);
    }catch(error){}
    updateStock();
    form?.addEventListener('change',()=>queueMicrotask(updateStock));
    document.addEventListener('variant:change',updateStock);
    document.addEventListener('product:variant-change',updateStock);
    window.addEventListener('popstate',updateStock);
    const ticker=setInterval(()=>{if(!root.isConnected){clearInterval(ticker);return;}updateStock();},900);
    change.addEventListener('click',()=>{
      change.hidden=true;
      zipForm.hidden=false;
      result.textContent='';
      zipInput.focus();
    });
    zipForm.addEventListener('submit',async event=>{
      event.preventDefault();
      const zip=zipInput.value.trim();
      if(!/^[0-9]{5}$/.test(zip)){
        result.textContent='Enter a valid 5-digit US ZIP code.';
        zipInput.focus();
        return;
      }
      const thisRequest=++requestId;
      button.disabled=true;
      result.textContent='Checking ZIP code…';
      try{
        const response=await fetch(`https://api.zippopotam.us/us/${encodeURIComponent(zip)}`,{signal:AbortSignal.timeout(8000)});
        if(thisRequest!==requestId)return;
        if(response.status===404){result.textContent='ZIP code not found. Please check and try again.';return;}
        if(!response.ok)throw new Error('lookup failed');
        const data=await response.json();
        const place=data.places?.[0];
        if(!place)throw new Error('no matching place');
        const location={zip,city:place['place name'],state:place['state abbreviation']};
        showLocation(location);
        try{sessionStorage.setItem(storageKey,JSON.stringify(location));}catch(error){}
      }catch(error){
        if(thisRequest===requestId)result.textContent='Could not check this ZIP right now. Please try again.';
      }finally{
        if(thisRequest===requestId)button.disabled=false;
      }
    });
  }
  function initMcDeliveryZips(){document.querySelectorAll('[data-mc-delivery-zip]').forEach(initMcDeliveryZip);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initMcDeliveryZips,{once:true});
  else initMcDeliveryZips();
  document.addEventListener('shopify:section:load',initMcDeliveryZips);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product_tabs"] && !Shopify.designMode) return;
  try {
    (function () {
  function bindProductAccordions(scope) {
    scope.querySelectorAll('.t4s-product-tabs-wrapper [data-t4s-accordion-pr]').forEach(function (tabs) {
      if (tabs.hasAttribute('data-mc-animation-ready')) return;
      tabs.setAttribute('data-mc-animation-ready', '');
      tabs.addEventListener('click', function (event) {
        var title = event.target.closest('[data-t4s-tab-wrapper] > [data-t4s-tab-item]');
        if (!title || title.closest('[data-t4s-accordion-pr]') !== tabs) return;
        var jquery = window.jQuery_T4NT;
        if (!jquery) return;
        tabs.querySelectorAll('[data-t4s-tab-content]').forEach(function (panel) {
          if (panel.closest('[data-t4s-accordion-pr]') === tabs) {
            jquery(panel).stop(true, true);
          }
        });
      }, true);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bindProductAccordions(document);
    }, { once: true });
  } else {
    bindProductAccordions(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    bindProductAccordions(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
